import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';

import { dashboardLayoutComponent } from '../layouts/dashboard-layout-route';

// The router's default search parser JSON-parses values, so a purely numeric
// param (e.g. `kyc=1`, `search=123`) arrives as a number. Coerce those back to a
// string so downstream consumers keep receiving the type they expect.
const usersSearchSchema = z.object({
  tab: z.enum(['active', 'pending']).optional(),
  user_status: z.string().optional(),
  kyc: z.coerce.string().optional(),
  is_email_verified: z.union([z.string(), z.boolean()]).optional(),
  soft_delete_include: z.union([z.string(), z.boolean()]).optional(),
  start_at: z.string().optional(),
  end_at: z.string().optional(),
  search: z.coerce.string().optional(),
  page: z.union([z.string(), z.number()]).optional(),
  limit: z.union([z.string(), z.number()]).optional(),
});

export const usersRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/users',
  validateSearch: usersSearchSchema,
  component: lazyRouteComponent(() => import('@/pages/users/users-page')),
});

export const detailUsersRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/users/$id',
  component: lazyRouteComponent(() => import('@/pages/users/detail')),
});
